export const YYYY_MM_DD_FORMAT = 'YYYY-MM-DD';